import { sendRegOtp } from 'api';
import {  Bookings,  PaymentOtp } from 'config/routersConstants';/** Bug #823 - Appointment recall url management for - Registered Hello Health users @Author Jithin Kuriakose @Date 06Apr22**/
import localforage from 'localforage';
import { detectAndroidMobile } from './detectAndroid';
import { detectIOsMobile } from './detectIOs';

const { v4: uuidv4 } = require('uuid');

export const loadState = async () => {
  try {
    const serializedState = await localforage.getItem('state');
    //console.log('load state',serializedState);
    if (serializedState === null) {
      return undefined;
    }
    return serializedState;
  } catch (err) {
    return undefined;
  }
};
export const saveState = async state => {
  try {

    await localforage.setItem('state', state);
  } catch (err) {
    return undefined;
  }
};

/**
  * Bug #498
  * @Author Jithin Kuriakose
  * @Date 13 July 2021
  */
export const isDoctor = (account) => {
  return account?.type && account?.type == 2;
};


export const isDemographicsCompleted = (account) => {
  return account && (account.dateOfBirth && account.dateOfBirth !== "" && account.gender && account.gender !== "");
}
/** Bug #823 - Appointment recall url management for - Registered Hello Health users @Author Jithin Kuriakose @Date 06Apr22**/
export const redirectAppointmentUser = (resp, apptAction, account, history, providerData) => {
  const virtualData = apptAction === "recall" && 
  { pathname: Bookings.path, state: {...providerData,appointmentId: resp?.data?.data?.id} } 
  
  // { pathname: VirtualCheckInsPatient.path, state: { appointmentId: resp?.data?.data?.id, apptDate: resp?.data?.data?.scheduledDate, guid: resp?.data?.data?.practiceGuid, doctorName: (capitalize(resp?.data?.data?.firstName) + " " + capitalize(resp?.data?.data?.lastName)) } };
  // if (resp?.data?.data?.apptStatus && (resp?.data?.data?.apptStatus).toUpperCase() == "CONFIRMED" && apptAction !== "recall") {
  //   history.replace({ pathname: AppointmentListComponent.path });
  // } else {
    // if (isDemographicsCompleted(account)) {

    //   if( apptAction === "recall" && resp?.data?.data?.apptStatus && (resp?.data?.data?.apptStatus !== 'MISSED' && resp?.data?.data?.apptStatus !== 'CANCELLED' && resp?.data?.data?.apptStatus !== 'CANCELED' )  && resp?.data?.data?.rescheduledApptId !== 0)
    //   {
    //     Modal.error({
    //       content: "Appointment already rescheduled",
    //       okText: 'OK',
    //       okType: 'primary',
    //       onOk: () => {
    //         history.replace({ pathname: AppointmentListComponent.path });
    //           return false;
    //       },
    //     });
    //     return;
    //   }
    //   history.replace({ ...virtualData });
    // } else {
    //   history.replace({ pathname: DemographicInformation.path, state: { next: { ...virtualData } } });
    // }
  // }
}
export const sendOtpAndRedirect = async (appointmentCode, appointmentAction, history) => {
  await sendRegOtp(appointmentCode);
  history.replace({ pathname: PaymentOtp.path, state: { appointmentCode: appointmentCode, appointmentAction: appointmentAction} });/** Bug #823 - Appointment recall url management for - Registered Hello Health users @Author Jithin Kuriakose @Date 06Apr22**/
}
//End Bug #823
/**End Bug #498**/
/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
export const getPlatform = () => {

  const isAndroidMobile = detectAndroidMobile();
  const isIosMobile = detectIOsMobile();
  let platform;
  if(isAndroidMobile)
  {console.log('isAndroidMobile : ', isAndroidMobile);
    platform = "ANDROID";
  }else if(isIosMobile)
  {console.log('isIosMobile :', isIosMobile);
    platform = "IOS";
  }
  else {
    platform = fnBrowserDetect();
  }
  return platform;
}

export const getBrowserDeviceId = () => {
  return uuidv4();
}

export const fnBrowserDetect = () => {
    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "CHROME";
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "FIREFOX";
    } else if (userAgent.match(/safari/i)) {
        browserName = "SAFARI";
    } else if (userAgent.match(/opr\//i)) {
        browserName = "OPERA";
    } else if (userAgent.match(/edg/i)) {
        browserName = "EDGE";
    } else if (userAgent.indexOf("MSIE") != -1) {
        //IF IE > 10
        browserName = "IE";
    } else {
        browserName = "UNKNOWN";
    }

    return browserName;
};

//End Bug #855